import Swiper, {Thumbs, Navigation, Pagination } from 'swiper';

  Swiper.use([Thumbs, Navigation, Pagination]);
  const mySwiperOne = new Swiper('[data-gallery-top="1"]', {
    slidesPerView: 1,
    thumbs: {
      swiper: {
        el: '[data-thumbs="1"]',
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
      },
    },
    navigation: {
      nextEl: '[data-arrow="1"]',
    },
  });

  Swiper.use([Thumbs, Navigation, Pagination]);
  const mySwiperOTwo = new Swiper('[data-gallery-top="2"]', {
    slidesPerView: 1,
    thumbs: {
      swiper: {
        el: '[data-thumbs="2"]',
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
      },
    },
    navigation: {
      nextEl: '[data-arrow="2"]',
    },
  });

  Swiper.use([Thumbs, Navigation, Pagination]);
  const mySwiperThree = new Swiper('[data-gallery-top="3"]', {
    slidesPerView: 1,
    thumbs: {
      swiper: {
        el: '[data-thumbs="3"]',
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
      },
    },
    navigation: {
      nextEl: '[data-arrow="3"]',
    },
  });

  Swiper.use([Thumbs, Navigation, Pagination]);
  const mySwiperFour = new Swiper('[data-gallery-top="4"]', {
    slidesPerView: 1,
    thumbs: {
      swiper: {
        el: '[data-thumbs="4"]',
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
      },
    },
    navigation: {
      nextEl: '[data-arrow="4"]',
    },
  });

  Swiper.use([Thumbs, Navigation, Pagination]);
  const mySwiperFive = new Swiper('[data-gallery-top="5"]', {
    slidesPerView: 1,
    thumbs: {
      swiper: {
        el: '[data-thumbs="5"]',
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
      },
    },
    navigation: {
      nextEl: '[data-arrow="5"]',
    },
  });

  Swiper.use([Thumbs, Navigation, Pagination]);
  const mySwiperSix = new Swiper('[data-gallery-top="6"]', {
    slidesPerView: 1,
    thumbs: {
      swiper: {
        el: '[data-thumbs="6"]',
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
      },
    },
    navigation: {
      nextEl: '[data-arrow="6"]',
    },
  });

  Swiper.use([Thumbs, Navigation, Pagination]);
  const mySwiperSeven = new Swiper('[data-gallery-top="7"]', {
    slidesPerView: 1,
    thumbs: {
      swiper: {
        el: '[data-thumbs="7"]',
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
      },
    },
    navigation: {
      nextEl: '[data-arrow="7"]',
    },
  });
